import * as React from 'react';
import { useState } from 'react';
import { makeStyles } from '@fluentui/react-components';
import CollapsibleFAQ from './CollapsibleFAQ';
import { FAQ_CONSTANTS } from '../constants/faqConstants';

const useStyles = makeStyles({
  container: {
    maxWidth: '900px',
    margin: '4rem auto',
    padding: '0 1rem',
  },
  sectionTitle: {
    fontSize: '2rem',
    textAlign: 'center',
    color: 'var(--primary-color)',
    marginBottom: '1.5rem',
  },
  faqList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  muted: {
    fontSize: '1rem',
    color: '#6d4c41',
  },
});

const FAQSection: React.FC = () => {
  const classes = useStyles();
  const [expandedFaqs, setExpandedFaqs] = useState<{[key: string]: boolean}>({});

  const toggleFaq = (faqKey: string) => {
    setExpandedFaqs(prev => ({
      ...prev,
      [faqKey]: !prev[faqKey]
    }));
  };

  return (
    <section id={FAQ_CONSTANTS.SECTION_ID} className={classes.container} aria-labelledby={FAQ_CONSTANTS.TITLE_ID}>
      <h2 id={FAQ_CONSTANTS.TITLE_ID} className={classes.sectionTitle}>
        {FAQ_CONSTANTS.SECTION_TITLE}
      </h2>
      <div className={classes.faqList}>

        <CollapsibleFAQ 
          faqKey={FAQ_CONSTANTS.FAQS.VENUES.KEY} 
          question={FAQ_CONSTANTS.FAQS.VENUES.QUESTION}
          expandedFaqs={expandedFaqs}
          toggleFaq={toggleFaq}
        >
          <p className={classes.muted}>
            {FAQ_CONSTANTS.FAQS.VENUES.ANSWER.split('\n').map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index < FAQ_CONSTANTS.FAQS.VENUES.ANSWER.split('\n').length - 1 && <br />}
              </React.Fragment>
            ))}
          </p>
        </CollapsibleFAQ>

        <CollapsibleFAQ 
          faqKey={FAQ_CONSTANTS.FAQS.ATTIRE.KEY} 
          question={FAQ_CONSTANTS.FAQS.ATTIRE.QUESTION}
          expandedFaqs={expandedFaqs}
          toggleFaq={toggleFaq}
        >
          <p className={classes.muted}>
            {FAQ_CONSTANTS.FAQS.ATTIRE.ANSWER.split('\n').map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index < FAQ_CONSTANTS.FAQS.ATTIRE.ANSWER.split('\n').length - 1 && <br />}
              </React.Fragment>
            ))}
          </p>
        </CollapsibleFAQ>

        <CollapsibleFAQ 
          faqKey={FAQ_CONSTANTS.FAQS.CONTACT.KEY} 
          question={FAQ_CONSTANTS.FAQS.CONTACT.QUESTION}
          expandedFaqs={expandedFaqs}
          toggleFaq={toggleFaq}
        >
          <p className={classes.muted}>
            {FAQ_CONSTANTS.FAQS.CONTACT.ANSWER.replace('{EMAIL}', FAQ_CONSTANTS.EMAIL).split('\n').map((line, index) => {
              if (line.includes(FAQ_CONSTANTS.EMAIL)) {
                const parts = line.split(FAQ_CONSTANTS.EMAIL);
                return (
                  <React.Fragment key={index}>
                    {parts[0]}
                    <a href={`mailto:${FAQ_CONSTANTS.EMAIL}`}>{FAQ_CONSTANTS.EMAIL}</a>
                    {parts[1]}
                    {index < FAQ_CONSTANTS.FAQS.CONTACT.ANSWER.split('\n').length - 1 && <br />}
                  </React.Fragment>
                );
              }
              return (
                <React.Fragment key={index}>
                  {line}
                  {index < FAQ_CONSTANTS.FAQS.CONTACT.ANSWER.split('\n').length - 1 && <br />}
                </React.Fragment>
              );
            })}
          </p>
        </CollapsibleFAQ>
      </div>
    </section>
  );
};

export default FAQSection;